<template>
  <div>
    <el-form label-position="right" ref="form" :model="form.model" :rules="formRules" :validate-on-rule-change="false" label-width="120px">
      <el-row class="bottom20">
        <el-row class="column-name" justify="start">
          <span>合同基本信息</span>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="客户名称" prop="customerId">
              <customer-select v-show="editable" ref="customerSelect" v-model="form.model.customerId"
                               :disabled="!editable" filterable clearable size="small">
              </customer-select>
              <el-input v-show="!editable" v-model="form.model.customerName" :disabled="true" size="small"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldFormItemShow('customerId')">(原：{{form.oldModel.customerName}})</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="用户名称" prop="endUserId">
              <customer-select v-show="editable" v-model="form.model.endUserId" :disabled="!editable" filterable clearable size="small">
              </customer-select>
              <el-input v-show="!editable" v-model="form.model.endUserName" :disabled="true" size="small"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4" >
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldFormItemShow('endUserId')">(原：{{form.oldModel.endUserName}})</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="所属数据中心" prop="roomIds">
              <dictionary-select v-model="form.model.roomIds" :disabled="!editable" :factory-name="'room'" :params="{type: 'ALL'}"
                                 clearable filterable multiple size="small">
              </dictionary-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4" >
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldFormItemShow('roomIds')">(原：
              <dictionary-text :factory-name="'room'" :params="{type: 'ALL'}"
                               :value="form.oldModel.roomIds">
              </dictionary-text>
              )</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="是否阿里合同" prop="flag">
              <el-radio v-model="form.model.flag" :disabled="!flagEditable" :label="1" @click.native.prevent="handleClickOnRadio(1)">是</el-radio>
              <el-radio v-model="form.model.flag" :disabled="!flagEditable" :label="0" @click.native.prevent="handleClickOnRadio(0)">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldFormItemShow('flag')">&nbsp;&nbsp;(原：{{form.oldModel.flag === 1 ? '是' : '否'}})</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="合同名称" prop="name">
              <el-input v-model="form.model.name" :maxlength="60" placeholder="限60字符" :disabled="!editable" size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4" >
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldFormItemShow('name')">(原：{{form.oldModel.name}})</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="合同编号" prop="sid">
              <el-input v-model="form.model.sid" :maxlength="60" placeholder="限60字符" :disabled="!editable" size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldFormItemShow('sid')">(原：{{form.oldModel.sid}})</span>
          </el-col>

          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="开始日期" prop="startts">
              <el-date-picker v-model="form.model.startts" :disabled="!editable" placeholder="开始日期"
                              type="date" format="yyyy-MM-dd" value-format="timestamp" size="small">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldFormItemShow('startts')">(原：{{form.oldModel.startts | formatDate}})</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="结束日期" prop="endts">
              <el-date-picker v-model="form.model.endts" :disabled="!editable" placeholder="结束日期"
                              type="date" format="yyyy-MM-dd" value-format="timestamp" size="small">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldFormItemShow('endts')">(原：{{form.oldModel.endts | formatDate}})</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="合同类型" prop="contractType">
              <el-select v-model="form.model.contractType" :disabled="!editable" :clearable="true" size="small" class="width100">
                <el-option :value="'WHOLESALE'" :label="'批发'">
                </el-option>
                <el-option :value="'RETAIL'" :label="'零售'">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldFormItemShow('contractType')">
              (原：{{form.oldModel.contractType === 'WHOLESALE' ? '批发' : form.oldModel.contractType === 'RETAIL' ? '零售' : ''}})
            </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="合同机柜数" prop="contractCabinetCount">
              <el-input v-model="form.model.contractCabinetCount" :disabled="!editable" size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4" >
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldFormItemShow('contractCabinetCount')">(原：{{form.oldModel.contractCabinetCount}})</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="授权人员" prop="userIdsArray">
              <person-select v-model="form.model.userIdsArray" :athub-value-key="'personuid'" :disabled="true"
                             :filterable="true" :clearable="true" :multiple="true" size="small" v-if="!editable">
              </person-select>
              <person-select v-model="form.model.userIdsArray" :eq-status="'1'" :personuids="personuids" :athub-value-key="'personuid'"
                             :filterable="true" :clearable="true" :multiple="true" size="small" v-if="editable">
              </person-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-if="persons != null" v-show="getOldFormItemShow('userIdsArray')">(原：{{getPersonNamesByIds(form.oldModel.userIdsArray)}})</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="录入人员" prop="inputUsername">
              <el-input v-model="form.model.inputUsername" :disabled="true" size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="录入时间" prop="inputTs">
              <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="timestamp"
                              v-model="form.model.inputTs" :disabled="true"
                              type="date"
                              placeholder="录入时间" size="small">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="20" :lg="20">
            <el-form-item label="备注" prop="comment">
              <el-input v-model="form.model.comment" :maxlength="500" placeholder="限500字符" :disabled="!editable" size="small" type="textarea">
              </el-input>
              <span class="old-data" v-show="getOldFormItemShow('comment')">(原：{{form.oldModel.comment}})</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>

      <ContractTerms ref="contractTermsRef" :model="form.model" :old-model="form.oldModel" :canEdited="!editable" source="contract" @termChanged="onTermsChange" />

      <el-row class="bottom20">
        <el-row class="column-name" justify="start">
          <span>收款信息</span>
          <div class="navbar-right">
          </div>
        </el-row>
        <el-row>
          <receipt-cfg-page-dialog ref="receiptCfgPageDialog" @confirm="handleConfirm">
          </receipt-cfg-page-dialog>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="收款单位" prop="receiptConfigId">
              <el-input v-model="form.model.receiptConfig.corporation" :readonly="true" :disabled="!editable" size="small">
                <template slot="append">
                  <el-button icon="el-icon-search" :disabled="!editable"
                             @click="$refs.receiptCfgPageDialog.open()">

                  </el-button>
                  <el-button icon="el-icon-circle-plus-outline" :disabled="!editable"
                             @click="$refs.receiptCfgFormDialog.open()">
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
            <receipt-cfg-form-dialog ref="receiptCfgFormDialog" @save-success="handleConfirm">
            </receipt-cfg-form-dialog>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldReceiptConfigShow('corporation')">
              (原：{{form.oldModel.receiptConfig.corporation}})
            </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="开户银行" prop="bank">
              <el-input v-model="form.model.receiptConfig.bank" :readonly="true" :disabled="!editable" size="small" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-if="persons != null" v-show="getOldReceiptConfigShow('bank')">
              (原：{{form.oldModel.receiptConfig.bank}})
            </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="账号" prop="account">
              <el-input v-model="form.model.receiptConfig.account" :readonly="true" :disabled="!editable" size="small" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-if="persons != null" v-show="getOldReceiptConfigShow('account')">
              (原：{{form.oldModel.receiptConfig.account}})
            </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="联系人" prop="contact">
              <el-input v-model="form.model.receiptConfig.contact" :readonly="true" :disabled="!editable" size="small" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-if="persons != null" v-show="getOldReceiptConfigShow('contact')">
              (原：{{form.oldModel.receiptConfig.contact}})
            </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="电话" prop="phone">
              <el-input v-model="form.model.receiptConfig.phone" :readonly="true" :disabled="!editable" size="small" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-if="persons != null" v-show="getOldReceiptConfigShow('phone')">
              (原：{{form.oldModel.receiptConfig.phone}})
            </span>
          </el-col>
        </el-row>
      </el-row>

      <!-- <el-row class="bottom20">
        <el-row class="column-name" justify="start">
          <span>关联商机</span>
          <div class="navbar-right">
            <business-opportunities-dialog ref="businessOpportunitiesDialog" @confirm="handleBusinessOpportunitiesDialogConfirm">
            </business-opportunities-dialog>
            <el-button type="info" plain size="minimum" @click="$refs.businessOpportunitiesDialog.open()" :disabled="!isCanUpdateBusinessOpportunities" >选择商机</el-button>
            <el-button type="info" plain size="minimum" @click="clearBusinessOpportunities" :disabled="!isCanUpdateBusinessOpportunities" >清空商机</el-button>
          </div>
        </el-row>
        <el-row v-if="form.model.businessOpportunities != null">
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="form.model.businessOpportunities.customerName" :readonly="true" :disabled="!isCanUpdateBusinessOpportunities" size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldBusinessOpportunitiesShow('customerName')">
              (原：{{form.oldModel.businessOpportunities == null ? '' : form.oldModel.businessOpportunities.customerName}})
            </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="客户编号" prop="customerCode">
              <el-input v-model="form.model.businessOpportunities.customerCode" :readonly="true" :disabled="!isCanUpdateBusinessOpportunities" size="small" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldBusinessOpportunitiesShow('customerCode')">
              (原：{{form.oldModel.businessOpportunities == null ? '' : form.oldModel.businessOpportunities.customerCode}})
            </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="销售负责人" prop="accountManager">
              <el-input v-model="form.model.businessOpportunities.accountManager" :readonly="true" :disabled="!isCanUpdateBusinessOpportunities" size="small" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldBusinessOpportunitiesShow('accountManager')">
              (原：{{form.oldModel.businessOpportunities == null ? '' : form.oldModel.businessOpportunities.accountManager}})
            </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="商机需求区域" prop="salesArea">
              <el-input v-model="form.model.businessOpportunities.salesArea" :readonly="true" :disabled="!isCanUpdateBusinessOpportunities" size="small" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldBusinessOpportunitiesShow('salesArea')">
              (原：{{form.oldModel.businessOpportunities == null ? '' : form.oldModel.businessOpportunities.salesArea}})
            </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="商机规模" prop="preSalesScaleComments">
              <el-input v-model="form.model.businessOpportunities.preSalesScaleComments" :readonly="true" :disabled="!isCanUpdateBusinessOpportunities" size="small" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldBusinessOpportunitiesShow('preSalesScaleComments')">
              (原：{{form.oldModel.businessOpportunities == null ? '' : form.oldModel.businessOpportunities.preSalesScaleComments}})
            </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8">
            <el-form-item label="商机需求时间" prop="time">
              <el-input v-model="form.model.businessOpportunities.time" :readonly="true" :disabled="!isCanUpdateBusinessOpportunities" size="small" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4">
            <span>&nbsp;&nbsp;</span>
            <span class="old-data" v-show="getOldBusinessOpportunitiesShow('time')">
              (原：{{form.oldModel.businessOpportunities == null ? '' : form.oldModel.businessOpportunities.time}})
            </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="20" :lg="20">
            <el-form-item label="商机详细描述" prop="comments">
              <el-input v-model="form.model.businessOpportunities.comments" :readonly="true" :disabled="!isCanUpdateBusinessOpportunities" size="small" type="textarea" />
              <span class="old-data" v-show="getOldBusinessOpportunitiesShow('comments')">
              (原：{{form.oldModel.businessOpportunities == null ? '' : form.oldModel.businessOpportunities.comments}})
            </span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row> -->
    </el-form>

    <attachment ownerTable='SALESCONTRACT'
                docType='SALESCONTRACT'
                :ownerId='form.model.id'
                :existed="form.model.id != null"
                :addable="isCanAddAttachment" :is-can-delete-file="isCanDeleteFile"
                @afterAttachDownloadFunc="afterAttachDownloadFunc">
    </attachment>

    <el-row class="bottom20" v-if="form.model.id != null">
      <el-row class="column-name" justify="start">
        <span>合同计费信息</span>
        <div class="navbar-right">
          <el-button type="info" plain size="minimum" @click="toAddContractItem" :disabled="!isCanAddContractItem">新增</el-button>
        </div>
        <span style="float:right;margin-right:20px;" v-if="form.model.flag === 0">
          注：
          <b style="color: #999999">灰色</b>部分代表数据删除，
          <b style="color: #E6A23C">橙色</b>部分代表数据修改，
          <b style="color: #66cc66">绿色</b>部分代表数据新增
        </span>
      </el-row>
      <el-row>
        <contract-item-list ref="contractItemList" :contract-id="form.model.id" :contract-workflow-status="form.model.workflowStatus"
                            :is-can-edit-contract-item="isCanEditContractItem"
                            :is-can-delete-contract-item="isCanDeleteContractItem"
                            @to-show="toShowContractItem"
                            @to-edit="toEditContractItem" @after-delete="handleAfterDeleteContractItem">
        </contract-item-list>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%">
          <contract-item-detail ref="contractItemDetail" :contract-flag="form.model.flag"
                                @after-save="handleAfterSaveContractItem"
                                @after-delete="handleAfterDeleteContractItem">
          </contract-item-detail>
          <div slot="footer" class="dialog-footer">
            <div v-if="itemOperation === 'detail.add' || itemOperation === 'detail.edit'">
              <el-button @click="dialogVisible = false" size="small">取 消</el-button>
              <el-button @click="dialogSave" size="small">保 存</el-button>
            </div>
            <div v-if="itemOperation === 'detail.show'">
              <el-button @click="dialogVisible = false" size="small">关 闭</el-button>
            </div>
          </div>
        </el-dialog>
      </el-row>
    </el-row>

    <el-row v-if="form.model.id != null && form.model.flag === 0">
      <el-row class="column-name" justify="start">
        <span>流转信息</span>
      </el-row>
      <el-row>
        <workflow ref="workflowHistory" bussiness="CONTRACT" :use-new-api="true"
                  :bussinessId="form.model.id" @loaded="afterLoadWorkflowHistory"></workflow>
      </el-row>
    </el-row>

    <el-row v-if="form.model.id != null && form.model.flag === 0">
      <el-row class="column-name" justify="start">
        <span>操作历史记录</span>
      </el-row>
      <el-row>
        <contract-record-detail-page :contract-id="form.model.id" ref="contractRecordDetailPage">
        </contract-record-detail-page>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import _ from 'lodash'
import Emitter from 'element-ui/src/mixins/emitter'

import DictionarySelect from "@/components/common/DictionarySelect"
import CustomerSelect from "@/components/billing/customer/customer.select"
import Attachment from "@/components/attachment"
import Workflow from "@/components/workflow"

import ContractItemList from './item/contract.item.list'
import ContractItemDetail from './item/contract.item.detail'
import {AuthInfo} from '@/util/user/authInfo'

import PersonServer from '@/api/person'
import PersonSelect from '@/views/workorder/components/person/person-select'

import {
  attachmentIsCanDelete,
  COMPONENT_DETAIL,
  COMPONENT_MAIN, contractCanAudit,
  contractCanSendWorkflow,
  contractIsCanUpdateBusinessOpportunities,
  contractIsCanAddAttachment,
  contractIsCanAddItem,
  contractItemIsCanDelete,
  contractItemIsCanEdit,
  ENUM_CONTRACT_WORKFLOW_STATUS_CONFIRMED,
  ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT,
  ENUM_CONTRACT_WORKFLOW_STATUS_WAPPRNEW,
  FN_LIST_QUERY,
  FN_SET_OPERATION,
  FN_SET_TAB,
  OPERATION_DETAIL_ADD,
  OPERATION_DETAIL_EDIT,
  OPERATION_DETAIL_SHOW,
  TAB_LIST,
} from "./contract.common";
import BillingServer from '@/api/billing'
import ReceiptCfgPageDialog from "@/views/billing/receiptcfg/receipt-cfg-page-dialog";
import ReceiptCfgFormDialog from "@/views/billing/receiptcfg/receipt-cfg-form-dialog";
import ContractTerms from "../contract-terms.vue";
import {handleError} from "@/util/error-util";
import {formatDate} from "element-ui/src/utils/date-util";
import DictionaryText from "../../../components/common/DictionaryText";
import BusinessOpportunitiesDialog from "@/components/billing/business-opportunities-dialog";
import ContractRecordDetailPage from "@/views/billing/contract/record/contract-record-detail-page";

export default {
    name: COMPONENT_DETAIL,
    componentName: COMPONENT_DETAIL,
    mixins: [Emitter],
    components: {
      ContractTerms,
      ContractRecordDetailPage,
      DictionaryText,
      BusinessOpportunitiesDialog,
      ReceiptCfgFormDialog,
      ReceiptCfgPageDialog,
      DictionarySelect,
      Attachment,
      Workflow,
      CustomerSelect,
      ContractItemList,
      ContractItemDetail,
      PersonSelect,
    },
    props: {
      operation: {
        type: String,
        default: OPERATION_DETAIL_SHOW
      },
      id: {
      },
    },
    data() {
      return {
        terms: [],
        termsStorable: true,
        persons: null,
        personuids: [],
        formModelLoaded: false,
        form: {
          model: {
            id: null,
            customerId: null,
            endUserId: null,
            roomIds: null,
            name: null,
            sid: null,
            startts: null,
            endts: null,
            inputUsername: null,
            inputTs: null,
            comment: null,
            contractType: null,
            contractCabinetCount: null,

            businessOpportunitiesId: null,
            businessOpportunities: {
              id: null,
              customerName: null,
              customerCode: null,
              accountManager: null,
              salesArea: null,
              preSalesScale: null,
              preSalesScaleComments: null,
              time: null,
              comments: null,
            },

            receiptConfigId: null,
            receiptConfig: {
              corporation: null,
              bank: null,
              account: null,
              contact: null,
              phone: null,
            },
            terms: [],
            termsStorable: true,

            status: null,

            flag: null,
            workflowStatus: null,
          },
          oldModel: {
            id: null,
            customerId: null,
            endUserId: null,
            roomIds: null,
            name: null,
            sid: null,
            startts: null,
            endts: null,
            inputUsername: null,
            inputTs: null,
            comment: null,
            contractType: null,

            businessOpportunitiesId: null,
            businessOpportunities: {
              id: null,
              customerName: null,
              customerCode: null,
              accountManager: null,
              salesArea: null,
              preSalesScale: null,
              preSalesScaleComments: null,
              time: null,
              comments: null,
            },

            receiptConfigId: null,
            receiptConfig: {
              corporation: null,
              bank: null,
              account: null,
              contact: null,
              phone: null,
            },

            status: null,

            flag: null,
            workflowStatus: null,
          },
        },

        attachmentLoaded: false,
        attachments: null,

        contractItemId: null,
        dialogTitle: '计费项',
        dialogVisible: false,


        itemOperation: '',

        workflowNodeLogs: null,
      }
    },
    computed: {
      formRules() {
        return {
          customerId: [
            { required: true, message: '请选择客户', trigger: 'change' },
          ],
          endUserId: [
            { required: true, message: '请选择用户', trigger: 'change' },
          ],
          roomIds: [
            { required: true, message: '请选择所属数据中心', trigger: 'change' }
          ],
          flag: [
            { required: true, message: '请填写是否阿里合同', trigger: 'change' },
          ],
          name: [
            { required: true, message: '请填写合同名称', trigger: 'blur' },
          ],
          sid: [
            { required: true, message: '请填写合同编号', trigger: 'blur' },
          ],
          startts: [
            { required: true, message: '请填写开始日期', trigger: 'blur' },
          ],
          endts: [
            { required: true, message: '请填写结束日期', trigger: 'blur' },
          ],
          contractType: [
            { required: true, message: '请选择合同类型', trigger: 'change' }
          ],
          userIdsArray: [
            { required: true, message: '请选择授权人员', trigger: 'change' }
          ],

          receiptConfigId: [
            { required: true, message: '请选择收款信息', trigger: 'change' },
          ],
        };
      },
      editable() {
        return (this.operation === OPERATION_DETAIL_ADD || this.operation === OPERATION_DETAIL_EDIT && this.form.model.id != null) &&
            (this.form.model.flag == null || this.form.model.flag === 1 ||
                this.form.model.flag === 0 && (this.form.model.workflowStatus == null ||
                    this.form.model.workflowStatus === 'DRAFT' || this.form.model.workflowStatus === 'WACHA'));
      },
      flagEditable() {
        /*return (this.operation === OPERATION_DETAIL_ADD || this.operation === OPERATION_DETAIL_EDIT && this.form.model.id != null) &&
            (this.form.model.flag == null || this.form.model.flag === 1 ||
                this.form.model.flag === 0 && (this.form.model.workflowStatus == null ||
                    this.form.model.workflowStatus === 'DRAFT' || this.form.model.workflowStatus === 'WACHA') &&
                (this.workflowNodeLogs == null || this.workflowNodeLogs.length === 0));*/
        return this.operation === OPERATION_DETAIL_ADD;
      },
      isCanUpdateBusinessOpportunities() {
        return contractIsCanUpdateBusinessOpportunities(this.form.model);
      },
      isCanAddAttachment() {
        return contractIsCanAddAttachment(this.form.model);
      },
      isCanAddContractItem() {
        return contractIsCanAddItem(this.form.model);
      },
    },
    watch: {
      id: {
        handler(value) {
          if (value != null) {
            this.look(value);
            this.$refs['form'].resetFields();
          }
        }
      },
      'form.model.customerId': {
        immediate: true,
        handler(value, oldValue) {
          if (value != null && String(value).trim() !== '') {
            let customer;
            let customers = this.$refs.customerSelect.customers;
            customers = customers.filter(e => String(e.id) === String(value));
            customer = customers == null || customers.length <= 0 ? null : customers[0];
            this.handleCustomerIdChange([value, customer], oldValue == null);
          }
        }
      },
    },
    methods: {
      onTermsChange(list) {
        this.form.model.terms = list
        this.form.model.termsStorable = true
        this.terms = list
        this.termsStorable = true
      },
      handleClickOnRadio(flag) {
        if (this.flagEditable) {
          if (this.form.model.flag === flag) {
            this.form.model.flag = null; // 取消选择
          } else {
            this.form.model.flag = flag;
          }
        }
        return this.flagEditable;
      },
      handleBusinessOpportunitiesDialogConfirm(businessOpportunities) {
        this.form.model.businessOpportunitiesId = businessOpportunities.id;
        this.form.model.businessOpportunities = businessOpportunities;
        let contractId = this.form.model.id;
        BillingServer.contract.modifyBusinessOpportunities(contractId, businessOpportunities).then((res) => {
          if (String(res.data.code) === '200' || res.data.success) {
            this.$message.success('保存成功');
            this.look(contractId);
            this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_DETAIL_SHOW);
          } else {
            this.$message.error(res.data.message);
          }
        }, (error) => {
          handleError(error);
        });
      },
      clearBusinessOpportunities() {
        this.form.model.businessOpportunitiesId = null;
        this.form.model.businessOpportunities = {
          id: null,
          customerName: null,
          customerCode: null,
          accountManager: null,
          salesArea: null,
          preSalesScale: null,
          preSalesScaleComments: null,
          time: null,
          comments: null,
        };
        let contractId = this.form.model.id;
        BillingServer.contract.modifyBusinessOpportunities(contractId, null).then((res) => {
          if (String(res.data.code) === '200' || res.data.success) {
            this.$message.success('保存成功');
            this.look(contractId);
            this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_DETAIL_SHOW);
          } else {
            this.$message.error(res.data.message);
          }
        }, (error) => {
          handleError(error);
        });
      },
      handleConfirm(receiptConfig) {
        this.form.model.receiptConfigId = receiptConfig.id;
        this.form.model.receiptConfig = receiptConfig;
      },
      handleCustomerIdChange(event, notResetUserIdsArray) {
        this.personuids = [];
        let customer = event[1];
        if (customer != null) {
          let customerIdsString = customer.userIds;
          if (customerIdsString != null) {
            this.personuids = customerIdsString.split(',').filter(e => e.trim() !== '');
          }
        }
        if (!notResetUserIdsArray) {
          let userIdsArray = [];
          if (this.personuids.filter(e => String(e) === String(AuthInfo.userId)).length > 0) {
            userIdsArray = [parseInt(AuthInfo.userId)];
          }
          this.form.model.userIdsArray = userIdsArray;
        }
      },
      getOldFormItemShow(key) {
        let cur = this.form.model;
        let old = this.form.oldModel;
        let show;
        if (old.id == null || cur.id == null || cur.flag !== 0 || cur.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT ||
            cur.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_WAPPRNEW ||
            cur.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_CONFIRMED) {
          return false;
        }
        if (key === 'roomIds' || key === 'userIdsArray') {
          let curValue = cur[key] == null ? null : JSON.parse(JSON.stringify(cur[key]));
          let oldValue = old[key] == null ? null : JSON.parse(JSON.stringify(old[key]));
          if (curValue == null && oldValue == null) {
            show = false;
          } else if (curValue == null || oldValue == null) {
            show = true;
          } else if (curValue.length !== oldValue.length) {
            show = true;
          } else {
            show = false;
            curValue.sort();
            oldValue.sort();
            for (let i = 0, len = curValue.length; i < len; i++) {
              if (curValue[i] !== oldValue[i]) {
                show = true;
                break;
              }
            }
          }
        } else {
          show = old != null && cur != null && old[key] !== cur[key];
        }
        return show;
      },
      getOldReceiptConfigShow(key) {
        let cur = this.form.model;
        let old = this.form.oldModel;
        if (old.id == null || cur.id == null || cur.flag !== 0 || cur.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT ||
            cur.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_WAPPRNEW ||
            cur.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_CONFIRMED) {
          return false;
        }
        let show = false;
        if (old.receiptConfigId !== cur.receiptConfigId && old.receiptConfig[key] !== cur.receiptConfig[key]) {
          show = true;
        }
        return show;
      },
      getOldBusinessOpportunitiesShow(key) {
        let cur = this.form.model;
        let old = this.form.oldModel;
        if (old.id == null || cur.id == null || cur.flag !== 0 || cur.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT ||
            cur.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_WAPPRNEW ||
            cur.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_CONFIRMED) {
          return false;
        }
        let show = false;
        if (old.businessOpportunitiesId !== cur.businessOpportunitiesId && old.businessOpportunities[key] !== cur.businessOpportunities[key]) {
          show = true;
        }
        return show;
      },
      getInitFormModel() {
        return {
          id: null,
          customerId: null,
          endUserId: null,
          roomIds: null,
          name: null,
          sid: null,
          startts: null,
          endts: null,
          inputUsername: null,
          inputTs: null,
          comment: null,
          contractType: null,

          businessOpportunitiesId: null,
          businessOpportunities: {
            id: null,
            customerName: null,
            customerCode: null,
            accountManager: null,
            salesArea: null,
            preSalesScale: null,
            preSalesScaleComments: null,
            time: null,
            comments: null,
          },

          receiptConfigId: null,
          receiptConfig: {
            corporation: null,
            bank: null,
            account: null,
            contact: null,
            phone: null,
          },

          status: null,

          flag: null,
          workflowStatus: null,
        };
      },
      async loadFormModel(id) {
        this.formModelLoaded = false;
        let responses = []
        try {
          responses = await Promise.all([
            BillingServer.contract.get(id),
            BillingServer.contract.findById(id),
          ]);
        } catch (error) {
          handleError(error);
        }
        if (responses[0].data.success && responses[1].data.success) {
          let models = await Promise.all([
              this._toModel(responses[0].data.data),
              this._toModel(responses[1].data.data),
          ]);
          this.form.model = models[0];
          this.form.oldModel = models[1] == null ? this.getInitFormModel() : models[1];
          this.formModelLoaded = true;
          this.dispatch(COMPONENT_MAIN, 'setDetailData', models[0]);
        } else if (!responses[0].data.success) {
          this.$message.error(responses[0].data.message);
        } else if (!responses[1].data.success) {
          this.$message.error(responses[1].data.message);
        }
      },
      toAdd() {
        /*this.dispatch(COMPONENT_MAIN, FN_SET_TAB, TAB_DETAIL);
        this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_DETAIL_ADD);*/
        this.form.model = {
          id: null,
          customerId: null,
          endUserId: null,
          roomIds: null,
          name: null,
          sid: null,
          startts: null,
          endts: null,

          comment: null,
          contractType: 'WHOLESALE',

          businessOpportunitiesId: null,
          businessOpportunities: {
            id: null,
            customerName: null,
            customerCode: null,
            accountManager: null,
            salesArea: null,
            preSalesScale: null,
            preSalesScaleComments: null,
            time: null,
            comments: null,
          },

          receiptConfigId: null,
          receiptConfig: {
            corporation: null,
            bank: null,
            account: null,
            contact: null,
            phone: null,
          },

          flag: 0,
          workflowStatus: 'DRAFT',

          status: 1,
          userIdsArray: [],
          inputUserId: AuthInfo.userId,
          inputUsername: AuthInfo.userRealName,
          inputTs: new Date().getTime(),
        };
        this.form.oldModel = this.getInitFormModel();
        this.$refs['form'].resetFields();
      },
      look(id) {
        this.loadPersons();
        this.loadFormModel(id);
        this.$nextTick(() => {
          this.reloadContractItems(id);
          this.$refs.contractTermsRef.getData()
          this.reloadWorkflowHistory();
          this.reloadContractRecordDetailPage();
        });
      },
      reloadContractItems(contractId) {
        // 计费项
        if (this.$refs.contractItemList != null) {
          this.$refs.contractItemList.loadContractItems(contractId);
        }
      },
      reloadWorkflowHistory() {
        // 工作流
        this.afterLoadWorkflowHistory(null);
        if (this.$refs.workflowHistory != null) {
          this.$refs.workflowHistory.getHistoryList();
        }
      },
      reloadContractRecordDetailPage() {
        if (this.$refs.contractRecordDetailPage != null) {
          this.$refs.contractRecordDetailPage.query();
        }
      },
      saveAdd() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let data = this._toData(this.form.model);
            BillingServer.contract.add(
                data, {loading: true}
            ).then((res) => {
              if (String(res.data.code) === '200' || res.data.success) {
                this.$message.success('保存成功');

                this._toModel(res.data.data).then(model => {
                  this.form.model = model;

                  this.look(model.id);
                  this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_DETAIL_SHOW);
                });

              } else {
                this.$message.error(res.data.message);
              }
            }, (error) => {
              handleError(error);
            });
          } else {
            return false;
          }
        });
      },
      saveEdit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let data = this._toData(this.form.model);
            BillingServer.contract.update(
                data['id'], data, {loading: true}
            ).then((res) => {
              if (String(res.data.code) === '200' || res.data.success) {
                this.$message.success('保存成功');

                this._toModel(res.data.data).then(model => {
                  this.form.model = model;

                  this.look(model.id);
                  this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_DETAIL_SHOW);
                });
              } else {
                this.$message.error(res.data.message);
              }
            }, (error) => {
              handleError(error);
            });
          } else {
            return false;
          }
        });
      },
      cancelEdit() {
        this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_DETAIL_SHOW);
        this.$refs['form'].resetFields();
        this.look(this.id);
      },
      reset() {
        let id = this.id;
        this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_DETAIL_SHOW);
        this.$refs['form'].resetFields();
        if (id != null) {
          this.look(this.id);
        }
      },
      toRemove() {
        if (this.workflowNodeLogs != null && this.workflowNodeLogs.length > 0) {
          this.$message.error('已经发送工作流不能删除！');
          return;
        }
        this.$confirm('确定删除吗？', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          BillingServer.contract.delete(this.form.model['id'], {loading: true}).then((res) => {
            if (res.data.code === 200 || res.data.success) {
              this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, FN_LIST_QUERY);
              this.dispatch(COMPONENT_MAIN, FN_SET_TAB, TAB_LIST);
              this.$message.success('删除成功！');
            } else {
              this.$message.error(`删除失败：${res.data.message}`);
            }
          }, (error) => {
            handleError(error);
          });
        }, () => {})
      },
      async _toModel(data) {
        let dataRoomIds = data.roomIds;
        let modelRoomIds = [];
        if (dataRoomIds != null && String(dataRoomIds).trim() !== '') {
          let roomIdStrs = dataRoomIds.split(',');
          modelRoomIds = roomIdStrs.filter(roomIdStr => roomIdStr.trim() !== '').map(roomIdStr => parseInt(roomIdStr.trim()));
        }
        data._roomIds = data.roomIds;
        data.roomIds = modelRoomIds;
        if (data.inputUserId != null) {
          let res;
          res = await PersonServer.personApi.get(data.inputUserId);
          if (String(res.data.code) === '200') {
            let person = res.data.data;
            if (person != null) {
              data.inputUsername = person.realname;
            } else {
              res = await PersonServer.userApi.get(data.inputUserId);
              if (String(res.data.code) === '200') {
                let user = res.data.data;
                data.inputUsername = user != null && user.person != null ? user.person.realname : data.inputUserId;
              }
            }
          }
        }
        let userIdsArray = [];
        if (data.userIds != null) {
          userIdsArray = _.uniq(data.userIds.split(',').map(userId => parseInt(userId)));
        }
        data.userIdsArray = userIdsArray;

        data.receiptConfig = data.receiptConfig == null ? {
          corporation: null,
          bank: null,
          account: null,
          contact: null,
          phone: null,
        } : data.receiptConfig;

        data.businessOpportunities = data.businessOpportunities == null ? {
          id: null,
          customerName: null,
          customerCode: null,
          accountManager: null,
          salesArea: null,
          preSalesScale: null,
          preSalesScaleComments: null,
          time: null,
          comments: null,
        } : data.businessOpportunities;

        if (data.customerId != null) {
          let res = await BillingServer.customer.get(data.customerId);
          if (res.data.success) {
            if (res.data.data != null) {
              data.customerName = res.data.data.name;
            }
          }
        }
        if (data.endUserId != null) {
          let res = await BillingServer.customer.get(data.endUserId);
          if (res.data.success) {
            if (res.data.data != null) {
              data.endUserName = res.data.data.name;
            }
          }
        }
        return data;
      },
      _toData(model) {
        let modelRoomIds = model.roomIds;
        model.roomIds = modelRoomIds == null ? "" : modelRoomIds.join(',');
        model.userIds = model.userIdsArray == null ? null : model.userIdsArray.join(',');
        model.terms = this.terms
        model.termsStorable = this.termsStorable
        return model;
      },
      async loadPersons() {
        let persons = this.persons;
        if (persons == null) {
          persons = await PersonServer.personApi.fetchByRedis({});
          this.persons = persons;
        }
        return persons;
      },
      getPersonNamesByIds(ids) {
        let names;
        if (ids == null || ids.length <= 0) {
          names = [];
        } else {
          let personsMap = _.keyBy(this.persons, 'id');
          names = [];
          for (let i = 0, len = ids.length; i < len; i++) {
            let person = personsMap[ids[i]];
            if (person == null) {
              names.push(ids[i]);
            } else {
              names.push(person.realName);
            }
          }
        }
        return names.join(', ');
      },
      async isCanSendWorkflow() {
        let can = false;
        if (!this.formModelLoaded ||  !this.attachmentLoaded) {
          this.$message.error('正在加载合同及其附件信息，请稍后...');
        } else {
          let formModel = this.form.model;
          let attachments = this.attachments;
          let result = contractCanSendWorkflow(formModel, attachments);
          if (!result.success) {
            this.$message.error(result.message);
            can = false;
          } else {
            can = true;
          }
        }
        return can;
      },
      async isCanAudit() {
        let can = false;
        if (!this.formModelLoaded ||  !this.attachmentLoaded) {
          this.$message.error('正在加载合同及其附件信息，请稍后...');
        } else {
          let formModel = this.form.model;
          let attachments = this.attachments;
          let result = contractCanAudit(formModel, attachments);
          if (!result.success) {
            this.$message.error(result.message);
            can = false;
          } else {
            can = true;
          }
        }
        return can;
      },
      afterAttachDownloadFunc(files) {
        this.attachmentLoaded = true;
        this.attachments = files;
      },
      toAddContractItem() {
        this.dialogVisible = true;
        this.itemOperation = 'detail.add';
        this.$nextTick(() => {
          this.$refs['contractItemDetail'].toAdd({
            contractId: this.form.model.id,
          });
        });
      },
      isCanEditContractItem(contractItem) {
        return contractItemIsCanEdit(this.form.model, contractItem);
      },
      isCanDeleteContractItem(contractItem) {
        return contractItemIsCanDelete(this.form.model, contractItem);
      },
      toShowContractItem(data) {
        this.dialogVisible = true;
        this.itemOperation = 'detail.show';
        this.$nextTick(() => {
          this.$refs['contractItemDetail'].toShow(data);
        });
      },
      toEditContractItem(data) {
        this.dialogVisible = true;
        this.itemOperation = 'detail.edit';
        this.$nextTick(() => {
          this.$refs['contractItemDetail'].toEdit(data);
        });
      },
      toDeleteContractItem(data) {
        this.$refs['contractItemDetail'].toDelete(data);
      },
      dialogSave() {
        if (this.itemOperation === 'detail.add') {
          this.$refs['contractItemDetail'].saveAdd();
        } else if (this.itemOperation === 'detail.edit') {
          this.$refs['contractItemDetail'].saveEdit();
        }
      },
      handleAfterSaveContractItem() {
        this.dialogVisible = false;
        this.reloadContractItems(this.form.model.id);
        this.reloadContractRecordDetailPage();
      },
      handleAfterDeleteContractItem() {
        this.dialogVisible = false;
        this.reloadContractItems(this.form.model.id);
        this.reloadContractRecordDetailPage();
      },
      async isCanDeleteFile(file) {
        let can = attachmentIsCanDelete(this.form.model, file);
        return can ? Promise.resolve(true) : Promise.reject('该附件不能删除！');
      },
      afterLoadWorkflowHistory(workflowNodeLogs) {
        let _workflowNodeLogs = workflowNodeLogs == null ? null : JSON.parse(JSON.stringify(workflowNodeLogs));
        this.workflowNodeLogs = _workflowNodeLogs;
        this.$emit('afterLoadWorkflowHistory', _workflowNodeLogs);
      },
    },
    mounted() {
    },
    filters: {
      formatDate(value, format) {
        return formatDate(value, format);
      }
    }
  }
</script>

<style scoped>
.old-data {
  line-height: 40px;
  color: #e6a23c;
}
</style>
